<div>
    <div class="container" style="border: 2px solid black">
      <div class="row">
        <!-- style="border-bottom-style: solid" -->
        <div class="col-2">
          <img
            style="margin-top: 19%"
            width="100%"
            src="../../../assets/img/brand/red.png"
          />
        </div>
        <div
          class="col-8"
          style="padding-top: 30px; text-align: center; padding-bottom: 10px"
        >
          <span style="font-size: 35px; font-weight: bold"
            >हिंदुस्थान प्रकाशन संस्था</span
          >
          <span style="font-size: 12px; margin-left: 05px"
            >(Reg.No.-BOM-3/1961(GBBSD)</span
          >
          <hr />
          <!-- <h3 style="margin-left: -130px; font-size: large">
            साप्ताहिक विवेक - पुस्तक विभाग
          </h3> -->
          <div class="row" style="text-align: left">
            <div class="col-6" style="padding-top: 10px">
              <span style="font-size: 14px"
                ><span style="font-weight: bold; font-size: 18px"
                  >प्रशासकीय कार्यालय :</span
                >
                116, 117, 118, 119, पहिला मजला, शिल्पीन सेंटर, ग. द. आंबेकर मार्ग, वडाळा , मुंबई - 400031.<br/></span>
              <span style="font-size: 12px"
                ><span style="font-weight: bold; font-size: 14px">दूरध्वनी:</span>
                27810235, 27810236
                <!-- <span style="font-weight: bold; font-size: 14px">फॅक्स:</span>
                27810237 -->
              </span>
            </div>
            <div
              class="col-6"
              style="
                border-style: solid;
                border-width: 0px 0px 0px 2px;
                padding-top: 10px;
              "
            >
              <span style="font-size: 14px"
                ><span style="font-weight: bold; font-size: 18px"
                  >मुख्य कार्यालय :
                </span>
                5/12, कामत औद्योगिक वसाहत, 396 स्वा. वीर सावरकर मार्ग, प्रभादेवी,
                मुंबई 4000 25.<br
              /></span>
              <span style="font-size: 12px"
                ><span style="font-weight: bold; font-size: 14px"
                  >दूरध्वनी :
                </span>
                24221440
                <!-- <span style="font-weight: bold; font-size: 14px">फॅक्स : </span>
                24363756 -->
                </span
              >
            </div>
          </div>
        </div>
        <div
          class="col-2"
          style="
            border-style: solid;
            border-width: 0px 0px 0px 2px;
            padding-top: 80px;
            text-align: center;
          "
        >
          <span style="font-weight: bold; font-size: 25px">कमिशन नोट</span>
        </div>
      </div>
      <div
        class="row"
        style="
          border-style: solid;
          border-width: 2px 0px 0px 0px;
          text-align: center;
        "
      >
        <!-- <div class="col-6" style="padding-top: 20px; text-align: left">

          <span style="font-weight: bold; font-size: 14px"
            >Representative Name :&nbsp;</span
          ><span style="font-size: 13px">{{ this.selectedBooks[0]['rep_name'] }}</span
          ><br />
          <span style="font-weight: bold; font-size: 14px">Address :&nbsp;</span
          ><span style="font-size: 13px">{{ this.selectedBooks[0]['rep_address'] }}</span
          ><br />
        </div> -->

        <div class="col-6" style="padding-top: 20px; text-align: left">
        <div style="margin-bottom: 10px;">
          <span style="font-weight: bold; font-size: 14px;">Representative Name :&nbsp;</span>
          <span style="font-size: 15px;">{{ this.selectedBooks[0]['rep_name'] }}</span>
        </div>
      
        <div style="margin-top: 10px;">
          <span style="font-weight: bold; font-size: 14px;">Address :&nbsp;</span>
          <span style="font-size: 15px;">
            <!-- {{ note.commission_no_data[0]["receiver_address"] + ', ' + note.commission_no_data[0]["rep_taluka"] 
              + ', ' +
            note.commission_no_data[0]["rep_district"] + ', ' + note.commission_no_data[0]["rep_mobile_no"] -->
                {{  selectedBooks[0]?.rep_address + ', ' +
                    bookcreditdata[0][0]?.rep_taluka + ', ' +
                    bookcreditdata[0][0]?.rep_district + ', ' +
                    bookcreditdata[0][0]?.rep_pincode + ', ' +
                    bookcreditdata[0][0]?.rep_mobile_no
                  }}
          </span>
          
        </div>
      </div>
        <div
          class="col-6"
          style="border-style: solid; border-width: 0px 0px 0px 2px"
        >
          <div
            class="row"
            style="
              border-style: solid;
              border-width: 0px 0px 2px 0px;
              text-align: center;
              padding-top: 20px;
              padding-bottom: 10px;
            "
          >
            <div class="col-8" style="text-align: left">
              <span style="font-weight: bold; font-size: 14px"
              
                >कमिशन नोट क्रं : </span
              ><span>{{ this.crdtNoteData["commino"] }}</span>
            </div>
            <div class="col-4" style="text-align: left">
              <span style="font-weight: bold; font-size: 14px">दिनांक :&nbsp;</span
              ><span style="font-size: 14px">{{
                this.crdtNoteData["recptdate"] | date: "dd-MM-yyy"
              }}</span>
            </div>
          </div>
          <!-- <div class="row" style="padding-top: 20px">
            <div class="col-12" style="text-align: left">
              <span style="font-weight: bold; font-size: 14px"
                >दिलेले रुपये&nbsp;</span
              >
              <span style="font-size: 14px">{{ crdtnotetotal  }} /-</span>
              <div class="col-12" style="text-align: right">
                <span style="font-weight: bold; font-size: 14px"
                  >मात्रची कमिशन देण्यात आले.</span
                >
              </div>
              
            </div>
            
          </div> -->
          <div class="row" style="padding-top: 20px">
            <div class="col-6" style="text-align: left">
              <span style="font-weight: bold; font-size: 14px">दिलेले रुपये :&nbsp;</span>
              <span style="font-size: 14px">{{ crdtnotetotal }} /-</span>
            </div>
            <div class="col-6" style="text-align: right">
              <span style="font-weight: bold; font-size: 14px">
                मात्रची कमिशन देण्यात आले.
              </span>
            </div>
          </div>
          
          <!-- Added margin-top: 10px to this row -->
          <!-- <div class="row" style="margin-top: 10px">
            <div class="col-5" style="text-align: left">
              <span style="font-weight: bold; font-size: 14px">Voucher Date :&nbsp;</span>
              <span style="font-size: 14px">
                {{ this.crdtNoteData["recptdate"] | date: "dd-MM-yyyy" }}
              </span>
            </div>
            <div class="col-7" style="text-align: right">
              <span style="font-weight: bold; font-size: 14px">Voucher No :&nbsp;</span>
              <span style="font-size: 14px">
                {{ this.crdtNoteData["crdtvno"] }}
              </span>
            </div>
          </div> -->

            <div class="row" style="margin-top: 10px">
          <div class="col-12" style="text-align: left">
            <span style="font-weight: bold; font-size: 14px">Voucher No :&nbsp;</span>
            <span style="font-size: 15px">
            {{ this.crdtNoteData["crdtvno"] }}
            </span>
          </div>
        </div>
        <div class="row" style="margin-top: 10px">
          <div class="col-12" style="text-align: left">
            <span style="font-weight: bold; font-size: 14px">Voucher Date :&nbsp;</span>
            <span style="font-size: 15px">
           {{ this.crdtNoteData["recptdate"] | date: "dd-MM-yyyy" }}
            </span>
          </div>
        </div>
          
          
          <div class="row">
            <div
              class="col-12"
              style="text-align: left; padding-top: 10px; padding-bottom: 10px"
            >
              <span style="font-weight: bold; font-size: 14px"
                >अक्षरी रक्कम : &nbsp;</span
              ><span style="font-size: 14px">{{ this.crdtnotetotalwords }}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row"
        style="
          border-style: solid;
          border-width: 2px 0px 0px 0px;
          text-align: center;
          margin-top: 10px;
          font-size: 15px;
        "
      >
        <!-- <div class="col-12" style="text-align: left">
          <span style="font-weight: bold; font-size: 14px">बिल नंबर: </span>
          <span style="font-size: 12px" *ngFor="let book of bookpymtrcptdata"
            >{{ book["invoice_no"] }}, &nbsp;</span
          >
        </div> -->
        <!-- <div class="row" style="margin-left: 2%"> -->
          <div class="tableDescheader pt-1" style="width: 14.28%">बिल तारीख</div>
          <div class="tableDescheader pt-1" style="width: 14.28%">बिल नंबर</div>
          <div class="tableDescheader pt-1" style="width: 14.28%">बिल रक्कम</div>
          <div class="tableDescheader pt-1" style="width: 14.28%">बिल जमा रक्कम</div>
          <div class="tableDescheader pt-1" style="width: 14.28%">बिल कमिशन रक्कम</div>
          <div class="tableDescheader pt-1" style="width: 14.28%">कमिशन नोट रक्कम</div>
          <div class="tableDescheader pt-1" style="width: 14.28%">कमिशन देणे बाकी</div>
        <!-- <div class="col-2 tableDescheader">Remark</div> -->
        <!-- </div> -->
      </div>
      <div class="row" *ngFor="let item of this.selectedBooks">
        <div class=" tableDesc" style="width: 14.28%">
          {{ this.item["invoice_date"] }}
        </div>
        <div class=" tableDesc" style="width: 14.28%">
          {{ this.item["invoice_no"] }}
        </div>
        <div class=" tableDesc"style="width: 14.28%">
          {{ this.item['invoice_total']}}
        </div>
        <div class=" tableDesc"style="width: 14.28%">
          {{ item['invoice_received_amt'] }}
        </div>
        <div class=" tableDesc"style="width: 14.28%">
          {{ item["commission"] }}
        </div>
        <!-- <div class="col-2 tableDesc">
          {{ this.item["total_remaining_amt"] }}
        </div> -->
        <div class=" tableDesc"style="width: 14.28%">{{ item["received_amt"] }}</div>
        <div class="tableDesc"style="width: 14.28%">
          {{ item["remaining_amt"]}}
        </div>
        <!-- <div class="col-2 tableDesc">
          {{ item["remarks"] }}
        </div> -->
      </div>
      <div class="row">
        <div class="tableDesc" style="font-weight: bold;width: 14.28%;font-size: medium">
          Total -
        </div>
        <div class="tableDesc" style="font-weight: bold;width: 14.28%; font-size: medium">
          
        </div>
        <div class="tableDesc" style="font-weight: bold;width: 14.28%; font-size: medium">
          {{ this.invTotalAmount}}
        </div>
        <div class="tableDesc" style="font-weight: bold;width: 14.28%; font-size: medium">
          {{ this.invRecvTotalAmount}}
        </div>
        <div class="tableDesc" style="font-weight: bold;width: 14.28%; font-size: medium">
          {{ this.totalamount }}
        </div>
        <!-- <div class="col-2 tableDesc" style="font-weight: bold; font-size: medium">
         {{ this.totalremainingamt}} 
        </div> -->
        <div class="tableDesc" style="font-weight: bold;width: 14.28%; font-size: medium">
          {{ this.crdtnoteamttotal }}
        </div>
        <div class="tableDesc" style="font-weight: bold;width: 14.28%; font-size: medium">
          {{ remainingTotal }}
        </div>
        <!-- <div class="col-2 tableDesc"></div> -->
      </div>
  
  
      <!-- </div> -->
      <div class="row" style="margin-top: 3%; padding-bottom: 1%">
        <div
          class="col-12"
          style="text-align: right; font-weight: bold; font-size: 14px;padding-top: 100px;"
        >
          <span>व्यवस्थापक / लेखापाल</span>
        </div>
      </div>
    </div>
    <button
      class="noPrint"
      style="margin-top: 2%"
      (click)="save()"
      mat-raised-button
      color="primary"
    >
      Save
    </button>
    <button
      class="noPrint"
      style="margin-top: 2%; margin-left: 10px"
      (click)="print()"
      mat-raised-button
      color="primary"
    >
      Print
    </button>
    <button
      class="noPrint"
      style="margin-top: 2%; margin-left: 10px"
      mat-button
      mat-dialog-close
    >
      Close
    </button>
  </div>
  